import React, {FC, ReactElement} from 'react';
import {SnackbarKey, useSnackbar} from 'notistack';
import {observer} from 'mobx-react';
import {reaction} from 'mobx';
import {notificationStore} from "../../store/NotificationStore";


export const Notifier: FC = observer((): ReactElement => {
    let displayed: SnackbarKey[] = [];
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const storeDisplayed = (id: SnackbarKey) => {
        displayed = [...displayed, id];
    };

    reaction(() => notificationStore.notificationsToShow.slice(),
            (notifications) => {
                notifications.forEach((notification) => {
                    // Do nothing if snackbar is already displayed
                    if (displayed.includes(notification.key)) return;
                    // Display snackbar using notistack
                    enqueueSnackbar(notification.message, notification.options);
                    // Keep track of snackbars that we've displayed
                    storeDisplayed(notification.key);
                    // Dispatch action to remove snackbar from mobx store
                });
                notificationStore.onNotificationShown(notifications.map(it => it.key));
            });

    reaction(() => notificationStore.notificationsToHide.slice(),
            (notificationsToHide) => {
                notificationsToHide.forEach(key => closeSnackbar(key))
                notificationStore.onNotificationHidden(notificationsToHide)
            });
    return <>
    </>
});